import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import Firestore = firebase.firestore.Firestore;
import Auth = firebase.auth.Auth;

export interface Response {
  read: boolean;
}

export function newResponse(): Response {
  return {
    read: false
  };
}

export class ResponseService {
  private firestore: Firestore;
  private auth: Auth;

  constructor() {
    this.firestore = firebase.firestore();
    this.auth = firebase.auth();
  }

  getResponse(docId: string) {
    return this.document(docId);
  }

  async setRead(docId: string, read: boolean) {
    await this.document(docId).set(
      {
        read
      },
      {
        merge: true
      }
    );
  }

  private document(docId: string) {
    const uid = this.auth.currentUser!!.uid;
    return this.firestore.doc(`users/${uid}/responses/${docId}`);
  }
}
